import styled, { keyframes } from 'styled-components';

const pop = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
`;

export const ChipButton = styled.button<{ $index: number }>`
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 500;
  color: var(--gray-darkest);
  background: var(--color-white);
  border: 1.5px solid var(--gray-light);
  border-radius: 999px;
  cursor: pointer;
  opacity: 0;
  animation: ${pop} 0.3s ease forwards;
  animation-delay: ${({ $index }) => $index * 0.08}s;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;

  &:hover:not(:disabled) {
    background: var(--brand-primary);
    border-color: var(--brand-primary);
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
